<h1 i18n>Wachtwoord vergeten?</h1>

<p i18n>
    Vul je emailadres hieronder in. Je zal een email ontvangen met instructies
    om je wachtwoord opnieuw in te stellen.
</p>

<form [formGroup]="form" (ngSubmit)="submit()">
    <div>
        <label for="email" class="form-label" i18n>Emailadres</label>
        <input id="email" type="email" autocomplete="email" class="form-control" [class.is-invalid]="
                form.controls.email.touched && form.controls.email.invalid
            " [formControl]="form.controls.email" />
        @for (error of emailErrors$ | async; track $index) {
        <p class="invalid-feedback">
            {{ error }}
        </p>
        }
    </div>
    <button type="submit" class="btn btn-primary my-3">
        <span i18n>Versturen</span>
        @if (loading$ | async) {
        <div class="spinner-border spinner-border-sm ms-1" role="status">
            <span class="visually-hidden" i18n>
                Verzoekt wachtwoordherstellink...
            </span>
        </div>
        }
    </button>
</form>
